import { cx } from '@linaria/core';
import { useRef, useMemo } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { breakpoints, resets } from '@ui/css';
import { Panel, CloseButton, Button } from '@ui/kit';
import { useMatchBreakpoint, useToggleState, SizeTransition } from '@utils/react';
import { AllLink } from '../atoms/all-link.js';
import { Empty } from '../atoms/empty.js';
import { heading } from '../atoms/heading.style.js';
import { useFilters } from '../hook.filters.js';
import { Card } from '../molecules/card/card.js';
import { ToggleFilterButton } from '../molecules/filters/atom.toggle-filter-button.js';
import { Filters } from '../molecules/filters/filters.js';
import { applyFilters } from '../util.apply-filters.js';
import { scrollAnchor, headingCls, contentWrapperCls, filtersCls, gridWrapperCls, gridCls, gridTransitionDurationMs, gridItemCls, allLinkCls, filterOverlayCls, filterOverlayButtonCls, wrapperCls } from './grid.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CardsGrid(props) {
  const scrollAnchorRef = useRef(null);
  const isMobile = useMatchBreakpoint(breakpoints.mobile.andDown());
  const filtersRef = useRef(null);
  const [filterOverlayOpen, overlayActions] = useToggleState(false);
  const [filters, dispatch] = useFilters();
  const filteredCards = useMemo(() => props.options.enableFilters ? applyFilters(props.cards, filters) : props.cards, [filters, props.cards, props.options.enableFilters]);
  return /*#__PURE__*/jsxs("article", {
    className: cx(wrapperCls, resets.rootCls, props.options.enableFilters && "filtersEnabled"),
    children: [/*#__PURE__*/jsx("div", {
      ref: scrollAnchorRef,
      className: scrollAnchor
    }), /*#__PURE__*/jsx("h2", {
      className: cx(heading, headingCls),
      "data-alignment": props.options.titleAlignment ?? "center",
      children: props.meta.title
    }), props.options.enableFilters && isMobile && /*#__PURE__*/jsx(ToggleFilterButton, {
      onClick: overlayActions.enable
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapperCls,
      children: [props.options.enableFilters && !isMobile && /*#__PURE__*/jsx("div", {
        className: filtersCls,
        ref: filtersRef,
        children: /*#__PURE__*/jsx(Filters, {
          cards: props.cards,
          dispatch: action => {
            dispatch(action);
            scrollAnchorRef.current?.scrollIntoView({
              block: "nearest",
              behavior: "smooth"
            });
          },
          filters: filters
        })
      }), /*#__PURE__*/jsx("div", {
        className: gridWrapperCls,
        children: /*#__PURE__*/jsx(TransitionGroup, {
          component: null,
          children: /*#__PURE__*/jsx(SizeTransition, {
            axis: "vertical",
            swappable: true,
            timeout: gridTransitionDurationMs,
            classNames: gridCls,
            getMinSizeInPx: () => ({
              height: filtersRef.current?.clientHeight
            }),
            children: ref => filteredCards.length === 0 ? /*#__PURE__*/jsx("div", {
              ref: ref,
              children: /*#__PURE__*/jsx(Empty, {})
            }) : /*#__PURE__*/jsx("ul", {
              ref: ref,
              className: gridCls,
              children: filteredCards.map((card, index) => /*#__PURE__*/jsx("li", {
                className: gridItemCls,
                children: /*#__PURE__*/jsx(Card, {
                  card: card,
                  layout: "grid"
                })
              }, index))
            })
          }, filteredCards.map(it => it.title).join("-"))
        })
      }), props.link && /*#__PURE__*/jsx(AllLink, {
        ...props.link,
        className: allLinkCls
      })]
    }), props.options.enableFilters && /*#__PURE__*/jsx(Panel, {
      position: "left",
      active: filterOverlayOpen,
      onClose: overlayActions.disable,
      children: /*#__PURE__*/jsxs("div", {
        className: filterOverlayCls,
        children: [/*#__PURE__*/jsx(CloseButton, {
          label: "Luk filter dialog",
          onClose: overlayActions.disable
        }), /*#__PURE__*/jsx(Filters, {
          cards: props.cards,
          dispatch: dispatch,
          filters: filters
        }), /*#__PURE__*/jsx(Button, {
          className: filterOverlayButtonCls,
          theme: "primary",
          onClick: overlayActions.disable,
          children: "Se filtrering"
        })]
      })
    })]
  });
}

export { CardsGrid };
//# sourceMappingURL=grid.js.map
